// extracted by mini-css-extract-plugin
export default {"root":"CartIconBadge_root__QEQ5D","icon":"CartIconBadge_icon__Cfk2p","badge":"CartIconBadge_badge__5QEwC"};